module.exports = __webpack_public_path__ + "img/57.5d3dc89.svg";